import { render, staticRenderFns } from "./hotelPublishControl.vue?vue&type=template&id=ec69ad24&scoped=true"
import script from "./hotelPublishControl.vue?vue&type=script&lang=js"
export * from "./hotelPublishControl.vue?vue&type=script&lang=js"
import style0 from "./hotelPublishControl.vue?vue&type=style&index=0&id=ec69ad24&prod&scoped=true&lang=css"
import style1 from "./hotelPublishControl.vue?vue&type=style&index=1&id=ec69ad24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec69ad24",
  null
  
)

export default component.exports